"use strict";

exports.__esModule = true;

// Helper to call a given function, only once
exports.default = function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/styled-components/lib/utils/once.js
 ** module id = 648
 ** module chunks = 0
 **/